import { BusinessOutcomesType } from 'domain/projects/newProject/businessOutcomes/types';
import { MilestonesType } from 'domain/projects/newProject/milestones/types';
import { RisksType } from 'domain/shared/newProject';
import { StakeholderSearchResultItem } from 'domain/projects/newProject/stakeholders/types';
import { AssumptionType } from 'domain/projects/newProject/assumptions/types';

export const reuseGroups = ['businessOutcomes', 'milestones', 'risks', 'stakeholders', 'assumptions'] as const;
export type ReuseGroup = (typeof reuseGroups)[number];

export type TransferResult = {
  succeeded: string[];
  failed: string[];
};

export type ReuseCandidateItem = { status?: string; type?: string };

type GroupItem = { id: string; status?: string; type?: string };

export interface PredecessorProject {
  id: string;
  legacyId?: number;
  name?: string;
  health?: { createdAt?: string } | null;
  accountData?: { accountId?: string | number } | null;
  milestones?: GroupItem[];
  businessOutcomes?: GroupItem[];
  risks?: GroupItem[];
  stakeholders?: GroupItem[];
  assumptions?: GroupItem[];
}

export interface PredecessorSource {
  id: string;
  health?: { createdAt?: string } | null;
  businessOutcomes?: BusinessOutcomesType[];
  milestones?: MilestonesType[];
  risks?: RisksType[];
  stakeholders?: StakeholderSearchResultItem[];
  assumptions?: AssumptionType[];
}

export type SelectableProject = {
  id: string;
  health?: { createdAt?: string } | null;
} & Partial<Record<ReuseGroup, readonly unknown[]>>;

export interface ReuseSelection<T extends SelectableProject> {
  predecessor: T | null;
  transferableGroups: ReuseGroup[];
  hasTransferableData: boolean;
  isFirstReuse: boolean;
}

export interface ReuseGroupConfig {
  label: string;
  isTransferable: (item: ReuseCandidateItem) => boolean;
  extract: (data?: PredecessorSource) => unknown[];
  mapForCreate: (items: unknown[], context: TransferContext) => unknown[];
}

interface TransferContext {
  projectManager?: string;
  userAlias?: string;
}
